import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getters, actions } from "../model";
import { getters as SessionFlyOverGetters } from "Portal/NewPortal/Sections/Sessions/FlyOver/model";
import { noop } from "utils/General";
import SessionFlyOver from "Portal/NewPortal/Sections/Sessions/FlyOver/View";
import TasksFlyOver from "Portal/NewPortal/Sections/Home/Cards/Tasks/FlyOver/View";
import ResourcesFlyOver from "Portal/NewPortal/Sections/Resources/FlyOver/View";

const decorate = connect(
  state => ({
    flyOverWidth: getters.flyOverWidth(state),
    openFromHomePage: SessionFlyOverGetters.fromHomePage(state)
  }),
  {
    setFlyOverWidth: actions.setFlyOverWidth
  }
);

const MOBILE_MAX_SCREENWIDTH = 1280;
const FLYOVER_WIDTH = 500;

const Layout = ({
  flyOverWidth = null,
  openFromHomePage = false,
  setFlyOverWidth = noop
}) => {
  useEffect(() => {
    // Call calculateWidth initially
    const calculateWidth = () => {
      const screenWidth = window.innerWidth;
      if (!openFromHomePage || !setFlyOverWidth) {
        return null;
      }

      if (screenWidth < MOBILE_MAX_SCREENWIDTH && openFromHomePage) {
        //mobile devices
        if (flyOverWidth !== screenWidth) {
          setFlyOverWidth(screenWidth);
        }
      } else if (flyOverWidth !== FLYOVER_WIDTH) {
        setFlyOverWidth(FLYOVER_WIDTH);
      }

      return true;
    };
    calculateWidth(openFromHomePage, setFlyOverWidth);

    // Add event listener to recalculate on window resize
    window.addEventListener("resize", calculateWidth);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", calculateWidth);
    };
  }, [openFromHomePage, flyOverWidth]);

  return (
    <>
      {flyOverWidth && <SessionFlyOver />}
      {flyOverWidth && <TasksFlyOver />}
      {flyOverWidth && <ResourcesFlyOver />}
    </>
  );
};

export default decorate(Layout);
